import { use } from 'react'

import { PageNavigatorContext } from './PageNavigator'

export default function PageNavigatorHost() {
	const { getHeader } = use(PageNavigatorContext)
	const header = getHeader()

	return header
}
